import { ProjectFormTypeEnum } from 'shared'
import { RoutesEnum } from '../enums/RoutesEnum'

export const getRouteForProjectFormType = (formType: ProjectFormTypeEnum): string => {
  switch (formType) {
    case ProjectFormTypeEnum.BUILDING_PERMIT_ACCOMPANYING_REPORT:
      return RoutesEnum.ACCOMPANYING_REPORT
    case ProjectFormTypeEnum.BUILDING_PERMIT_TECHNICAL_FORM:
      return RoutesEnum.TECHNICAL_REPORT_FORM
    case ProjectFormTypeEnum.DEMOLITION_PERMIT_ACCOMPANYING_REPORT:
      return RoutesEnum.DEMOLITION_ACCOMPANYING_REPORT
    case ProjectFormTypeEnum.DEMOLITION_PERMIT_TECHNICAL_FORM:
      return RoutesEnum.DEMOLITION_TECHNICAL_REPORT_FORM

    default:
      throw new Error(`No registered route for ${formType}`)
  }
}
